import { createClient } from '@supabase/supabase-js';
import bcrypt from 'bcryptjs';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL || '';
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY || '';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export interface Shipment {
  id: number;
  tracking_id: string;
  sender_name: string;
  receiver_name: string;
  origin: string;
  destination: string;
  weight: number;
  mode_of_transportation?: string;
  status: 'Created' | 'In Transit' | 'Delivered' | 'Cancelled';
  remarks?: string;
  created_by?: string;
  created_by_email?: string;
  created_at: string;
  created_at_timestamp?: string;
  updated_at: string;
}

export interface ShipmentUpdate {
  id: number;
  tracking_id: string;
  location: string;
  status:
    | 'Created'
    | 'At Port'
    | 'At Airport'
    | 'Waiting for Clearance'
    | 'At Pick Up Location'
    | 'Ready for Pick Up'
    | 'In Transit'
    | 'Out for Delivery'
    | 'Delivered';
  remarks?: string;
  updated_at: string;
}

export const generateTrackingId = (): string => {
  // Get current date in YYMMDD format
  const now = new Date();
  const year = now.getFullYear().toString().slice(-2); // Last 2 digits of year
  const month = (now.getMonth() + 1).toString().padStart(2, '0'); // Month with leading zero
  const day = now.getDate().toString().padStart(2, '0'); // Day with leading zero
  const dateStr = year + month + day;
  
  // Generate 4-digit random number (1-9999, zero-padded)
  const randomNum = Math.floor(Math.random() * 9999) + 1;
  const randomStr = randomNum.toString().padStart(4, '0');
  
  return `IBX${dateStr}${randomStr}`;
};

// Password hashing utilities
const SALT_ROUNDS = 10;

export const hashPassword = async (password: string): Promise<string> => {
  return await bcrypt.hash(password, SALT_ROUNDS);
};

export const verifyPassword = async (password: string, hashedPassword: string): Promise<boolean> => {
  return await bcrypt.compare(password, hashedPassword);
};
